import { setCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

const COUNTER_COOKIE_NAME = 'newbuilding-search-frontend.chatAnimationCounter';
const ANIMATION_SHOWN_COUNT_COOKIE_NAME = 'newbuilding-search-frontend.chatAnimationShownCount';
const TOOLTIP_ANIMATION_COOKIE_NAME = 'newbuilding-search-frontend.chatTooltipAnimationShown';
const PREV_PATH_COOKIE_NAME = 'newbuilding-search-frontend.chatAnimationPrevPath';

export function getChatAnimationCounter(): number {
  if (typeof window === 'undefined') {
    return 0;
  }

  const cookies = parseCookies(window.document.cookie);
  const counter = cookies[COUNTER_COOKIE_NAME];

  if (counter === undefined || counter === '') {
    return 0;
  }

  const parsedCounter = parseInt(counter, 10);

  return isNaN(parsedCounter) ? 0 : parsedCounter;
}

export function incrementChatAnimationCounter(): number {
  const currentCounter = getChatAnimationCounter();
  const newCounter = currentCounter + 1;
  const cookieConfig = { expires: 365 * 86400, secure: false };

  setCookie(COUNTER_COOKIE_NAME, String(newCounter), cookieConfig);

  return newCounter;
}

export function getTooltipAnimationCookie(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const cookies = parseCookies(window.document.cookie);
  const cookie = cookies[TOOLTIP_ANIMATION_COOKIE_NAME];

  return cookie === '1';
}

export function setTooltipAnimationCookie(): void {
  const cookieConfig = { expires: 365 * 86400, secure: false };

  setCookie(TOOLTIP_ANIMATION_COOKIE_NAME, '1', cookieConfig);
}

export function getPrevPathCookie(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const cookies = parseCookies(window.document.cookie);
  const prevPath = cookies[PREV_PATH_COOKIE_NAME];

  return prevPath || null;
}

export function setPrevPathCookie(path: string): void {
  const cookieConfig = { expires: 365 * 86400, secure: false };

  setCookie(PREV_PATH_COOKIE_NAME, path, cookieConfig);
}

export function getAnimationShownCount(): number {
  if (typeof window === 'undefined') {
    return 0;
  }

  const cookies = parseCookies(window.document.cookie);
  const count = cookies[ANIMATION_SHOWN_COUNT_COOKIE_NAME];

  if (count === undefined || count === '') {
    return 0;
  }

  const parsedCount = parseInt(count, 10);

  return isNaN(parsedCount) ? 0 : parsedCount;
}

export function setAnimationShownCountCookie(count: number): void {
  const cookieConfig = { expires: 365 * 86400, secure: false };

  setCookie(ANIMATION_SHOWN_COUNT_COOKIE_NAME, String(count), cookieConfig);
}
